import { Injectable } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/ban-types
declare let fbq: Function;

@Injectable({
  providedIn: 'root',
})
export class FacebookPixelService {
  private eventsEnabled = false;

  eventEmitter(eventType: 'track' | 'trackCustom', eventName: string, extraData?: object): void {
    if (typeof fbq === 'function' && this.eventsEnabled) {
      fbq(eventType, eventName, extraData);
    }
  }

  trackPageView(url: string): void {
    if (typeof fbq === 'function' && this.eventsEnabled) {
      fbq('track', 'PageView', { page: url });
    }
  }

  initializeOnStartup(): void {
    if (typeof fbq === 'function') {
      this.eventsEnabled = false;
      fbq('consent', 'revoke');
    }
  }
  enablePixelEvents(): void {
    if (typeof fbq === 'function') {
      this.eventsEnabled = true;
      fbq('consent', 'grant');
    }
  }
}
